/**
 * Invokes a function after a specified duration.
 *
 * @param {Function} cb - The callback function to run after the specified duration.
 * @param {Number} ms - The timeout in milliseconds.
 *
 * @returns {Function} A function to stop the timer.
 *
 * @example
 * const stopTimeout = startTimeout(() => {
 *   console.log('One second!');
 * }, 1000);
 * stopTimeout();
 * // Nothing logged
 */
export function startTimeout (cb, ms) {
  const timeoutId = setTimeout(cb, ms);
  return () => clearTimeout(timeoutId);
}
